import { useCallback, useRef } from "react";
import { useAppDispatch } from "../../redux/hooks";
import { closeModal, openModal } from "../../redux/uireducers/modalstrip";

function useModalStrip() {
  const timeIntervalRef = useRef<NodeJS.Timeout | null>(null);
  const dispatch = useAppDispatch();

  const showModalStrip = useCallback((modalType: string, message: any, time: number = 5000) => {
    if (timeIntervalRef.current) {
      clearTimeout(timeIntervalRef.current);
    }

    let textMessage = "An unexpected error occurred.";
    if (typeof message === "string" && message.trim()) {
      textMessage = message.trim();
    } else if (message instanceof Error && message.message) {
      textMessage = message.message;
    } else if (message && typeof message === "object") {
      textMessage = message.message || message.error || message.msg || message.detail || JSON.stringify(message);
    }

    dispatch(openModal({ modalType, message: textMessage }));

    timeIntervalRef.current = setTimeout(() => {
      dispatch(closeModal());
    }, time);
  }, [dispatch]);

  return { showModalStrip };
}

export default useModalStrip;
